import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
} from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
/**
 * @deprecated Instead use `canViewFeature` functional guard, which supports localization
 */
export class FeatureFlagGuard implements CanActivateChild, CanActivate {
  constructor(private readonly router: Router) {}

  static isFeatureActive(feature: string) {
    if (environment.features[feature] !== undefined) {
      return environment.features[feature];
    }
    return true;
  }

  canActivate(route: ActivatedRouteSnapshot) {
    if (!FeatureFlagGuard.isFeatureActive(route.data.feature)) {
      return this.router.parseUrl('/');
    }
    return true;
  }

  canActivateChild(route: ActivatedRouteSnapshot) {
    return this.canActivate(route);
  }
}
